import React, { useEffect, useState } from "react";

const PHASES = [
  { label: "Breathe in", duration: 4000 },
  { label: "Hold", duration: 4000 },
  { label: "Breathe out", duration: 4000 },
  { label: "Hold", duration: 4000 },
];

export default function BreathingCircle({ running }) {
  const [phaseIdx, setPhaseIdx] = useState(0);

  useEffect(() => {
    if (!running) return;
    const t = setTimeout(() => setPhaseIdx((i) => (i + 1) % PHASES.length), PHASES[phaseIdx].duration);
    return () => clearTimeout(t);
  }, [phaseIdx, running]);

  useEffect(() => { if (!running) setPhaseIdx(0); }, [running]);

  const phase = PHASES[phaseIdx];
  const scale = phase.label === "Breathe in" ? 1 : phase.label === "Breathe out" ? 0.7 : phase.label === "Hold" && phaseIdx === 1 ? 1 : 0.7;

  return (
    <div className="flex flex-col items-center py-6" data-testid="breathing-circle">
      <div
        className="relative w-56 h-56 flex items-center justify-center"
      >
        <div
          className="absolute inset-0 rounded-full bg-teal-100"
          style={{
            transform: running ? `scale(${scale})` : "scale(0.8)",
            transition: `transform ${PHASES[phaseIdx].duration}ms ease-in-out`,
          }}
        />
        <div className="absolute inset-6 rounded-full bg-teal-50 border border-teal-200" />
        <div className="relative font-display text-2xl font-bold text-teal-900" data-testid="breathing-phase-label">
          {running ? phase.label : "Ready"}
        </div>
      </div>
      <p className="text-sm text-slate-500 mt-4">Box breathing · 4-4-4-4</p>
    </div>
  );
}
